<template>
  <div class="full-screen">
    <LoadingSpinner v-if="isLoading" />
    <div v-else class="html">
      <iframe :srcdoc="modifiedHTML" />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from '../components/widgets/LoadingSpinner.vue';
import {
  getFlowPublicAccess,
  getWorkFlowAttribute,
} from '../services/axios/data.api';
import { runFlowByID } from '../services/axios/flow-runner.api';
import { mapGetters } from 'vuex';
export default {
  name: 'ProcessRunner',
  data() {
    return {
      isLoading: true,
      htmlForm: null,
      customHTML:
        '<style>::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-track{background:#ffff;border-radius:10px}::-webkit-scrollbar-thumb{background:rgb(117 117 117);border-radius:10px}::-webkit-scrollbar-thumb:hover{background:#555}::-webkit-scrollbar-track{-webkit-box-shadow:none!important;background-color:transparent}::-webkit-scrollbar{width:7px!important;background-color:transparent}::-webkit-scrollbar-thumb{background-color:transparent}</style>',
    };
  },
  props: {
    params: Object,
    id: String,
    redirectURL: {
      required: false,
      default: null,
      type: String,
    },
  },
  methods: {
    async getHtmlForm() {
      try {
        const isPublicFlow = await this.getIsPublicFlow();
        if (!isPublicFlow && !this.user) {
          await this.$router.push({
            path: '/auth',
            query: {
              redirect: this.redirectURL
                ? this.redirectURL
                : this.$route.fullPath,
            },
          });
          return;
        }
        let flowExecutionURL = null;

        if (this.getAllFlows && this.getAllFlows.length) {
          const flow = this.getAllFlows.find((el) => el.id == this.processId);
          if (flow)
            flowExecutionURL = flow.executionUrl ? flow.executionUrl : null;
        } else {
          const flowData = await getWorkFlowAttribute(
            this.processId,
            'apiEndpoint'
          );
          if (flowData)
            flowExecutionURL =
              flowData?.data || 'https://flow-runner.api.codelos.io/v4';
        }
        const params = `?id=${this.processId}`;
        const response = await runFlowByID(
          flowExecutionURL,
          params,
          this.payload
        );
        this.htmlForm = response.data;
      } catch (error) {
        if (this.getAllFlows && this.getAllFlows.length) {
          await this.$router.push({
            path: '/',
            query: { section: 'flows', database: 'process-list' },
          });
        }
        this.$bvToast.toast(
          'Es gab ein Fehler beim Laden des Workflows. Bitte probieren Sie erneut oder melden Sie sich bei Ihrem Administrator',
          {
            title: 'Fehlerhaft',
            variant: 'danger',
            solid: true,
          }
        );
      } finally {
        this.isLoading = false;
      }
    },

    async getIsPublicFlow() {
      try {
        const response = await getFlowPublicAccess(this.processId);
        return response.data?.is_public;
      } catch (error) {
        throw new Error(error);
      }
    },
  },
  mounted() {
    this.getHtmlForm();
  },
  watch: {
    '$route.params'() {
      this.getHtmlForm();
    },
  },
  computed: {
    ...mapGetters(['getAllFlows']),
    user() {
      return this.$store.state.user;
    },
    processId() {
      if (this.id != null) return this.id;
      else return this.$route.params.id;
    },
    payload() {
      if (this.params != null) return this.params;
      else return this.$route.query;
    },
    modifiedHTML() {
      return this.htmlForm + this.customHTML;
    },
  },
  components: {
    LoadingSpinner,
  },
};
</script>

<style scoped>
body {
  line-height: 8px;
}

.full-screen {
  width: 100%;
  height: 100%;
}

.full-screen .html {
  width: 100%;
  height: 100%;
}

.full-screen .html iframe {
  width: 100%;
  height: calc(100% - 7px);
}
</style>
